// eslint-disable-next-line @typescript-eslint/ban-ts-comment
// @ts-nocheck

import { Route } from 'react-router-dom';

import { Layout } from '~/components';

import { Collaborators } from '../pages';

function CollaboratorsRoutes(): ReactElement {
  return (
    <Layout title="COLABORADORES">
      <Route
        path="/collaborators"
        exact
        component={Collaborators.CollaboratorsList}
      />
      <Route
        path="/collaborators/cadaster"
        component={Collaborators.CollaboratorsCadaster}
      />
    </Layout>
  );
}

export default CollaboratorsRoutes;
